import React, { Fragment, useState, useEffect } from 'react';
import * as Yup from 'yup';
import { makeStyles } from '@material-ui/core/styles';
import { Formik } from 'formik';

import numeral from 'numeral';

import PerfectScrollbar from 'react-perfect-scrollbar';

import Alerts from '../../utils/alerts';
import agm from '../../services/agm';
import FindProductLpu from '../productslpu/Find'
import CreateProductLpu from '../productslpu/Create'

import { IoMdCart } from "react-icons/io";
import { AiOutlineClear } from "react-icons/ai";
import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';


import {
    KeyboardDatePicker
} from '@material-ui/pickers';

import NumberFormat from 'react-number-format';

import {
    Tooltip,
    Avatar,
    Button,
    Box,
    colors,
    Icon,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TableContainer,
    TableFooter,
    Typography,
    Select,
    InputLabel,
    MenuItem,
    FormControl,
    Grid,
    Divider,
    Dialog,
    DialogContent,
    DialogTitle,
    TextField,
    Card,
    CardContent,
    withStyles,
    FormControlLabel,
    Checkbox,
    IconButton
} from '@material-ui/core';

const ColorCheckbox = withStyles({
    root: {
        marginLeft: 0,
        color: colors.cyan[400],
        '&$checked': {
            color: colors.cyan[500],
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: 680,
        backgroundColor: theme.palette.background.paper,
    },
    avatar: {
        marginRight: theme.spacing(1),
        backgroundColor: colors.grey[200]
    },
    container: {
        maxHeight: 390,
    },
    input: {
        color: colors.cyan['A700']
    },
    inputErro: {
        color: colors.red[900]
    },
    products: {
        padding: 0
    }
}));

const MODE_FULL = 0;
const MODE_COMPACT = 1;
const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const budgetColumns = [
    { name: 'Código', field: '(item.codigo) ? item.codigo : "..."', size: 150, sortable: 0, exportable: 0 },
    { name: 'Nome', field: 'item.nome', size: -1, sortable: 0, exportable: 0 },
    { name: 'Tipo', field: 'getNome(item.origem, dependencies.regions)', size: -1, sortable: 0, exportable: 0 },
    { name: 'Categoria', field: 'getNome(item.aplicacao, dependencies.applications)', size: -1, sortable: 0, exportable: 0 },
    { name: 'Qtd', field: 'formatDecimal(item.qtd)', size: -1, sortable: 0, exportable: 0 },
    { name: 'Unidade', field: 'getNome(item.unidade, dependencies,units)', size: -1, sortable: 0, exportable: 0 },
    { name: 'Material Unitário', field: 'formatDecimal(item.valor)', size: -1, sortable: 0, exportable: 0 },
    { name: 'Mão Obra Unitária', field: 'formatDecimal(item.instalacao)', size: -1, sortable: 0, exportable: 0 },
    { name: 'Total Material', field: 'formatDecimal(item.qtd * item.valor)', size: -1, sortable: 0, exportable: 0 },
    { name: 'Total Mão Obra', field: ' formatDecimal(item.qtd * item.instalacao)', size: -1, sortable: 0, exportable: 0 },
    { name: 'Total', field: ' formatDecimal(((item.valor * item.qtd) + (item.instalacao * item.qtd)))', size: -1, sortable: 0, exportable: 0 }

];

const budgetEmptyMessage = "Nenhum Produto Foi Adicionado.";

const budgetFullMode = {
    mode: MODE_FULL,
    create: LEVEL_ACCESS_HIDE,
    update: LEVEL_ACCESS_HIDE,
    delete: LEVEL_ACCESS_ENABLED,
    config: LEVEL_ACCESS_HIDE,
    export: LEVEL_ACCESS_HIDE,
    empty: budgetEmptyMessage,
    columns: budgetColumns
};

const budgetCompactMode = {
    mode: MODE_COMPACT,
    create: LEVEL_ACCESS_HIDE,
    update: LEVEL_ACCESS_HIDE,
    delete: LEVEL_ACCESS_ENABLED,
    config: LEVEL_ACCESS_HIDE,
    export: LEVEL_ACCESS_HIDE,
    empty: budgetEmptyMessage,
    columns: budgetColumns
};
const budgetResultModes = [budgetFullMode, budgetCompactMode];

const defaultProductLpu = {
    codigo: null,
    nome: null,
    UNIDADE: null,
    valor: 0.0,
    instalacao: 0.0,
    APLICACAO: null,
    REGIAO: -1
}

const getNome = (item, list) => {
    var nome = "??"
    if (item) {
        if (item.id) {
            nome = item.nome;
        } else {
            for (let index = 0; index < list.length; index++) {
                const element = list[index];
                if (element.id == item) {
                    nome = element.nome;
                    break;
                }
            }
        }
    }
    return nome;
}


const Budget = ({ item, open, closeEdition, updateValues, dependencies, selectedMode }) => {

    const classes = useStyles();
    const [openAlert, setOpenAlert] = useState(false);
    const [message, setMessage] = useState({});

    const [openFindProduct, setOpenFindProduct] = useState(false);
    const [openCreateProductDialog, setOpenCreateProductDialog] = useState(false);
    const [productLpu, setProductLpu] = useState(defaultProductLpu);

    const openCreateProduct = (values) => {
        setOpenCreateProductDialog(true)
    }

    const closeFindProduct = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenFindProduct(false);
    };


    const closeCreateProduct = (event, reason) => {
        setOpenCreateProductDialog(false);
    };

    const getRandomId = () => {
        var min = Math.ceil(9900);
        var max = Math.floor(10000);
        return parseInt(Math.floor(Math.random() * (max - min + 1)) + min) * -1;
    };

    const selectProduct = (values, produto) => {
        values.idProduto = produto.id;
        values.qtdProduto = 1;
        values.codigoProduto = produto.codigo;
        values.nomeProduto = produto.nome;
        values.valorProduto = numeral((produto.valor) ? produto.valor : 0).format('0.00');
        values.instalacaoProduto = numeral((produto.instalacao) ? produto.instalacao : 0).format('0.00');
        values.origemProduto = 1;
        values.aplicacaoProduto = produto.APLICACAO;
        values.unidadeProduto = produto.UNIDADE;
        values.produto = produto;
        closeFindProduct();
    }

    const createProductLpuValues = (pdlpu, values) => {
        agm.post('/produtoslpu', pdlpu).then((response) => {
            if (!response.data.error) {

                values.idProduto = pdlpu.id;
                values.qtdProduto = 1;
                values.codigoProduto = pdlpu.codigo;
                values.nomeProduto = pdlpu.nome;
                values.valorProduto = (pdlpu.valor) ? parseFloat(pdlpu.valor) : 0;
                values.instalacaoProduto = (pdlpu.instalacao) ? parseFloat(pdlpu.instalacao) : 0;
                values.produto = pdlpu;

                for (let index = 0; index < dependencies.applications.length; index++) {
                    const applic = dependencies.applications[index];
                    if (applic.id == pdlpu.APLICACAO) {
                        values.produto.aplicacao = applic;
                    }
                }

                for (let index = 0; index < dependencies.units.length; index++) {
                    const unt = dependencies.units[index];
                    if (unt.id == pdlpu.UNIDADE) {
                        values.produto.unidade = unt;
                    }
                }

                document.getElementById('qtdProduto').focus();
                document.getElementById('nomeProduto').focus();

                closeCreateProduct();
            }
            setMessage(response.data);
            setOpenAlert(true);
        }).catch((error) => {
            console.error(error);
            setMessage({ error: true, fatal: true, message: error.message });
            setOpenAlert(true);
        })
    }


    const clearFields = (values) => {
        values.idProduto = ''
        values.qtdProduto = '';
        values.codigoProduto = '';
        values.nomeProduto = '';
        values.lpuProduto = '';
        values.custoProduto = '';
        values.bdiProduto = '';
        values.valorProduto = '';
        values.instalacaoProduto = '';
        values.origemProduto = null;
        values.unidadeProduto = null;
        values.aplicacaoProduto = null;
        values.produto = null;
        document.getElementById('nomeProduto').focus();
        document.getElementById('codigoProduto').focus();
    }

    const handleAddItem = async (values) => {
        if (values.nomeProduto) {
            dependencies.items.push({
                id: getRandomId(),
                qtd: values.qtdProduto,
                valor: values.valorProduto,
                instalacao: values.instalacaoProduto,
                total: (parseFloat(parseFloat(values.valorProduto) * parseFloat(values.qtdProduto)) + (parseFloat(parseFloat(values.instalacaoProduto) * parseFloat(values.qtdProduto)))),
                nome: values.nomeProduto,
                codigo: values.codigoProduto,
                unidade: values.unidadeProduto,
                aplicacao: values.aplicacaoProduto,
                origem: values.origemProduto,
                produto: values.produto
            });

            values.valorMaoObra = 0.0;
            values.valorMaterial = 0.0;
            for (let index = 0; index < dependencies.items.length; index++) {
                var prod = dependencies.items[index];
                values.valorMaoObra = (parseFloat(values.valorMaoObra) + (parseFloat(parseFloat(prod.instalacao) * parseFloat(prod.qtd))));
                values.valorMaterial = (parseFloat(values.valorMaterial) + (parseFloat(parseFloat(prod.valor) * parseFloat(prod.qtd))));
            }
            values.total = parseFloat(parseFloat(values.valorMaoObra) + parseFloat(values.valorMaterial));
            values.idProduto = ''
            values.qtdProduto = '';
            values.codigoProduto = '';
            values.nomeProduto = '';
            values.lpuProduto = '';
            values.custoProduto = '';
            values.bdiProduto = '';
            values.valorProduto = '';
            values.instalacaoProduto = '';
            values.unidadeProduto = '';
            values.aplicacaoProduto = '';
            values.origemProduto = '';
            values.produto = null;
            document.getElementById('codigoProduto').focus();
        } else {
            setOpenFindProduct(true);
        }
    }

    const handleRemoveItem = async (item, values) => {
        for (let index = 0; index < dependencies.items.length; index++) {
            var prod = dependencies.items[index];
            if (prod.id == item.id) {
                dependencies.items.splice(index, 1);
                dependencies.removes.push(prod);
                break;
            }
        }
        values.valorMaoObra = 0.0;
        values.valorMaterial = 0.0;
        for (let index = 0; index < dependencies.items.length; index++) {
            prod = dependencies.items[index];
            values.valorMaoObra = (parseFloat(values.valorMaoObra) + (parseFloat(parseFloat(prod.instalacao) * parseFloat(prod.qtd))));
            values.valorMaterial = (parseFloat(values.valorMaterial) + (parseFloat(parseFloat(prod.valor) * parseFloat(prod.qtd))));
        }
        values.total = (parseFloat(values.valorMaoObra) + parseFloat(values.valorMaterial));
        document.getElementById('codigoProduto').focus();
        document.getElementById('nomeProduto').focus();
        document.getElementById('codigoProduto').focus();
    }


    const closeAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    return (
        <Fragment>

            <Alerts message={message}
                open={openAlert}
                closeAlert={closeAlert} />

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="xl" fullWidth>
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Editar Orçamento
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>

                    <Formik
                        initialValues={item}
                        validationSchema={
                            Yup.object().shape({
                                ocorrencia: Yup.string().required('Ocorrência é obrigatória'),
                                ORCAMENTISTA: Yup.string().required('A seleção do orçamentista é obrigatória'),
                                servicoExecutar: Yup.string().required("O serviço a ser executado é obrigatório")
                            })
                        }
                        onSubmit={(values, formik) => {
                            updateValues(values, dependencies.items, dependencies.removes);
                            formik.setSubmitting(false);
                        }}

                    >
                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            setFieldValue,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values
                        }) => (

                            <form onSubmit={handleSubmit}>

                                <FindProductLpu open={openFindProduct}
                                    closeFind={closeFindProduct}
                                    selectProduct={selectProduct}
                                    values={values}
                                    selectMode={selectedMode}
                                    applications={dependencies.applications}
                                    region={dependencies.region}
                                />

                                <CreateProductLpu open={openCreateProductDialog}
                                    item={productLpu}
                                    dependencies={dependencies}
                                    selectMode={selectedMode}
                                    ocurrence={values}
                                    createValues={createProductLpuValues}
                                    closeCreation={closeCreateProduct} />

                                <Box className={classes.root} mt={1} >

                                    <Grid
                                        container
                                        spacing={2}
                                        xs="auto"
                                    >

                                        <Grid
                                            item
                                            md={2}
                                            xs={12}>

                                            <TextField
                                                error={Boolean(touched.ocorrencia && errors.ocorrencia)}
                                                fullWidth
                                                required
                                                label="Ocorrência"
                                                margin="none"
                                                id="ocorrencia"
                                                name="ocorrencia"
                                                onBlur={e => {
                                                    handleBlur(e);
                                                }}
                                                onChange={handleChange}
                                                value={"OT " + values.ocorrencia.numero}
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                                inputProps={
                                                    { readOnly: true, }
                                                }
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={2}
                                            xs={12}>

                                            <TextField
                                                error={Boolean(touched.ccusto && errors.ccusto)}
                                                fullWidth
                                                required
                                                label="Centro Custo"
                                                margin="none"
                                                name="ccusto"
                                                id="ccusto"
                                                onBlur={handleBlur}
                                                onChange={value => setFieldValue("ccusto", value)}
                                                value={(values.ocorrencia && values.ocorrencia.unidade) ? values.ocorrencia.unidade.codigo : 'Erro'}
                                                variant="outlined"
                                                inputProps={
                                                    { readOnly: true, }
                                                }
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={4}
                                            xs={12}>

                                            <TextField
                                                error={Boolean(touched.unidade && errors.unidade)}
                                                fullWidth
                                                required
                                                label="Unidade"
                                                margin="none"
                                                name="unidade"
                                                id="unidade"
                                                onBlur={handleBlur}
                                                onChange={value => setFieldValue("unidade", value)}
                                                value={values.ocorrencia.unidade.nome}
                                                variant="outlined"
                                                inputProps={
                                                    { readOnly: true, }
                                                }
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={2}
                                            xs={12}>

                                            <KeyboardDatePicker
                                                error={Boolean(touched.abertura && errors.abertura)}
                                                fullWidth
                                                required
                                                readOnly
                                                cancelLabel="Cancelar"
                                                margin="none"
                                                inputVariant="outlined"
                                                id="abertura"
                                                label="Data de Ocorrência"
                                                format="DD/MM/YYYY"
                                                name="abertura"
                                                value={values.ocorrencia.abertura}
                                                onBlur={handleBlur}
                                                onChange={value => setFieldValue("abertura", value)}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={2}
                                            xs={12}>

                                            <TextField
                                                error={Boolean(touched.tipoOcorrencia && errors.tipoOcorrencia)}
                                                fullWidth
                                                required
                                                label="Tipo"
                                                margin="none"
                                                id="tipoOcorrencia"
                                                name="tipoOcorrencia"
                                                onBlur={handleBlur}
                                                onChange={value => setFieldValue("tipoOcorrencia", value)}
                                                value={(values.ocorrencia.tipoOcorrencia) ? values.ocorrencia.tipoOcorrencia.nome : "Não Informada"}
                                                variant="outlined"
                                                inputProps={
                                                    { readOnly: true, }
                                                }
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>


                                        <Grid
                                            item
                                            md={2}
                                            xs={12}>

                                            <TextField
                                                error={Boolean(touched.categoria && errors.categoria)}
                                                fullWidth
                                                required
                                                label="Categoria"
                                                margin="none"
                                                name="categoria"
                                                id="categoria"
                                                onBlur={handleBlur}
                                                onChange={value => setFieldValue("categoria", value)}
                                                value={(values.ocorrencia.categoria) ? values.ocorrencia.categoria.nome : "Não Informada"}
                                                variant="outlined"
                                                inputProps={
                                                    { readOnly: true, }
                                                }
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid

                                            item
                                            md={2}
                                            xs={12}>

                                            <TextField
                                                error={Boolean(touched.numero && errors.numero)}
                                                fullWidth
                                                required
                                                label="Orçamento"
                                                margin="none"
                                                name="numero"
                                                id="numero"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={numeral(values.numero).format('000000')}
                                                variant="outlined"
                                                inputProps={
                                                    { readOnly: true, }
                                                }
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={2}
                                            xs={12}>

                                            <KeyboardDatePicker
                                                fullWidth
                                                required
                                                cancelLabel="Cancelar"
                                                margin="none"
                                                inputVariant="outlined"
                                                id="dataCriacao"
                                                label="Data de Criação"
                                                format="DD/MM/YYYY"
                                                name="dataCriacao"
                                                value={values.dataCriacao}
                                                onBlur={handleBlur}
                                                onChange={value => setFieldValue("dataCriacao", value)}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={2}
                                            xs={12}>

                                            <FormControl variant="outlined" fullWidth margin="none">
                                                <InputLabel shrink htmlFor="FASE_ORCAMENTO" required >Fase de Orçamento</InputLabel>
                                                <Select notched
                                                    autosize={true}
                                                    required
                                                    readOnly
                                                    error={Boolean(touched.FASE_ORCAMENTO && errors.FASE_ORCAMENTO)}
                                                    helperText={touched.FASE_ORCAMENTO && errors.FASE_ORCAMENTO}
                                                    value={values.FASE_ORCAMENTO}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Fase de Orçamento"
                                                    variant="outlined"
                                                    inputProps={{
                                                        name: 'FASE_ORCAMENTO',
                                                        id: 'FASE_ORCAMENTO',
                                                    }}
                                                >
                                                    <MenuItem key={-1} value={null}>
                                                        <em>Selecione um</em>
                                                    </MenuItem>

                                                    {dependencies.phases.map((phase) => (
                                                        <MenuItem key={phase.id} value={phase.id}>{phase.nome}</MenuItem>
                                                    ))}

                                                </Select>
                                            </FormControl>

                                        </Grid>

                                        <Grid
                                            item
                                            md={2}
                                            xs={12}>

                                            <FormControl variant="outlined" fullWidth margin="none">
                                                <InputLabel shrink htmlFor="ORCAMENTISTA" required >Orçamentista</InputLabel>
                                                <Select notched
                                                    autosize={true}
                                                    required
                                                    error={Boolean(touched.ORCAMENTISTA && errors.ORCAMENTISTA)}
                                                    helperText={touched.ORCAMENTISTA && errors.ORCAMENTISTA}
                                                    value={values.ORCAMENTISTA}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Orçamentista *"
                                                    variant="outlined"
                                                    inputProps={{
                                                        name: 'ORCAMENTISTA',
                                                        id: 'ORCAMENTISTA',
                                                    }}
                                                >
                                                    <MenuItem key={-1} value={null}>
                                                        <em>Selecione um</em>
                                                    </MenuItem>

                                                    {dependencies.makers.map((maker) => (
                                                        <MenuItem key={maker.id} value={maker.id}>{maker.nome}</MenuItem>
                                                    ))}

                                                </Select>
                                            </FormControl>

                                        </Grid>

                                        <Grid
                                            item
                                            md={2}
                                            xs={12}>

                                            <KeyboardDatePicker
                                                fullWidth
                                                required={values.FASE_ORCAMENTO != 1}
                                                cancelLabel="Cancelar"
                                                margin="none"
                                                inputVariant="outlined"
                                                id="dataEnvio"
                                                label="Data de Envio"
                                                format="DD/MM/YYYY"
                                                name="dataEnvio"
                                                value={values.dataEnvio}
                                                onBlur={handleBlur}
                                                onChange={value => setFieldValue("dataEnvio", value)}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={12}
                                            xs={12}
                                        >
                                            <TextField
                                                error={Boolean(touched.servicoExecutar && errors.servicoExecutar)}
                                                required
                                                fullWidth
                                                label="Serviços a serem executados"
                                                maxRows={2}
                                                minRows={1}
                                                length={1024}
                                                multiline
                                                margin="none"
                                                name="servicoExecutar"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.servicoExecutar}
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                                inputProps={
                                                    { readOnly: false, }
                                                }
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            md={12}
                                            xs={12}>

                                            <Card className={classes.products}>
                                                <CardContent>

                                                    <Grid container
                                                        direction="row"
                                                        justifyContent="flex-start"
                                                        alignItems="center"
                                                        spacing={2}  >

                                                        <Grid
                                                            item
                                                            md={1}
                                                            xs={12}>

                                                            <TextField
                                                                fullWidth
                                                                label="Código"
                                                                margin="none"
                                                                name="codigoProduto"
                                                                id="codigoProduto"
                                                                onBlur={e => {
                                                                    handleBlur(e);
                                                                }}
                                                                onChange={handleChange}
                                                                value={values.codigoProduto}
                                                                variant="outlined"
                                                                InputLabelProps={{ shrink: true }}
                                                            />

                                                        </Grid>

                                                        <Grid
                                                            item
                                                            md={3}
                                                            xs={12}>

                                                            <TextField
                                                                fullWidth
                                                                label="Nome"
                                                                rows={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? 4 : 1}
                                                                multiline={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? true : false}
                                                                margin="none"
                                                                name="nomeProduto"
                                                                id="nomeProduto"
                                                                onBlur={handleBlur}
                                                                onChange={handleChange}
                                                                value={values.nomeProduto}
                                                                variant="outlined"
                                                                InputLabelProps={{ shrink: true }}
                                                            />
                                                        </Grid>

                                                        <Grid
                                                            item
                                                            md={1}
                                                            xs={12}>
                                                            <NumberFormat
                                                                fullWidth
                                                                label="Qtd"
                                                                margin="none"
                                                                name="qtdProduto"
                                                                id="qtdProduto"
                                                                onBlur={handleBlur}
                                                                onChange={handleChange}
                                                                value={values.qtdProduto}
                                                                variant="outlined"
                                                                decimalScale="2"
                                                                fixedDecimalScale="true"
                                                                customInput={TextField}
                                                                InputLabelProps={{ shrink: true }}
                                                            />

                                                        </Grid>

                                                        <Grid
                                                            item
                                                            md="auto"
                                                            xs={12}>

                                                            <FormControl variant="outlined" fullWidth margin="none">
                                                                <InputLabel shrink htmlFor="unidadeProduto" >Unidade</InputLabel>
                                                                <Select notched
                                                                    style={{ width: 100 }}
                                                                    autosize={true}
                                                                    value={values.unidadeProduto}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    label="Unidade"
                                                                    variant="outlined"
                                                                    inputProps={{
                                                                        name: 'unidadeProduto',
                                                                        id: 'unidadeProduto',
                                                                    }}
                                                                >
                                                                    <MenuItem key={-1} value={null}>
                                                                        <em>Selecione uma</em>
                                                                    </MenuItem>

                                                                    {dependencies.units.map((untss) => (
                                                                        <MenuItem key={untss.id} value={untss.id}>
                                                                            {untss.nome}
                                                                        </MenuItem>
                                                                    ))}

                                                                </Select>
                                                            </FormControl>

                                                        </Grid>

                                                        <Grid
                                                            item
                                                            md="auto"
                                                            xs={12}>

                                                            <FormControl variant="outlined" fullWidth margin="none">
                                                                <InputLabel shrink htmlFor="origemProduto" >Tipo</InputLabel>
                                                                <Select notched
                                                                    style={{ width: 180 }}
                                                                    autosize={true}
                                                                    value={values.origemProduto}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    label="Tipo"
                                                                    variant="outlined"
                                                                    inputProps={{
                                                                        name: 'origemProduto',
                                                                        id: 'origemProduto',
                                                                    }}
                                                                >
                                                                    <MenuItem key={-1} value={null}>
                                                                        <em>Selecione uma</em>
                                                                    </MenuItem>


                                                                    {dependencies.origins.map((orgins) => (
                                                                        <MenuItem key={orgins.id} value={orgins.id}>
                                                                            {orgins.nome}
                                                                        </MenuItem>
                                                                    ))}


                                                                </Select>
                                                            </FormControl>

                                                        </Grid>

                                                        <Grid
                                                            item
                                                            md="auto"
                                                            xs={12}>

                                                            <FormControl variant="outlined" fullWidth margin="none">
                                                                <InputLabel shrink htmlFor="aplicacaoProduto" >Categoria</InputLabel>
                                                                <Select notched
                                                                    style={{ width: 180 }}
                                                                    autosize={true}
                                                                    value={values.aplicacaoProduto}
                                                                    onChange={e => {
                                                                        handleChange(e);
                                                                    }}
                                                                    onBlur={handleBlur}
                                                                    label="Categoria"
                                                                    variant="outlined"
                                                                    inputProps={{
                                                                        name: 'aplicacaoProduto',
                                                                        id: 'aplicacaoProduto',
                                                                    }}
                                                                >
                                                                    <MenuItem key={-1} value={null}>
                                                                        <em>Selecione uma</em>
                                                                    </MenuItem>

                                                                    {dependencies.applications.map((applsprd) => (
                                                                        <MenuItem key={applsprd.id} value={applsprd.id}>
                                                                            {applsprd.nome}
                                                                        </MenuItem>
                                                                    ))}

                                                                </Select>
                                                            </FormControl>

                                                        </Grid>

                                                        <Grid
                                                            item
                                                            md={1}
                                                            xs={12}>
                                                            <NumberFormat
                                                                fullWidth
                                                                label="Valor Material"
                                                                margin="none"
                                                                name="valorProduto"
                                                                id="valorProduto"
                                                                onBlur={handleBlur}
                                                                onChange={handleChange}
                                                                value={values.valorProduto}
                                                                variant="outlined"
                                                                decimalScale="2"
                                                                fixedDecimalScale="true"
                                                                customInput={TextField}
                                                                InputLabelProps={{ shrink: true }}
                                                            />

                                                        </Grid>

                                                        <Grid
                                                            item
                                                            md={1}
                                                            xs={12}>
                                                            <NumberFormat
                                                                fullWidth
                                                                label="Valor Mão Obra"
                                                                margin="none"
                                                                name="instalacaoProduto"
                                                                id="instalacaoProduto"
                                                                onBlur={handleBlur}
                                                                onChange={handleChange}
                                                                value={values.instalacaoProduto}
                                                                variant="outlined"
                                                                decimalScale="2"
                                                                fixedDecimalScale="true"
                                                                customInput={TextField}
                                                                InputLabelProps={{ shrink: true }}
                                                            />

                                                        </Grid>

                                                        <Grid item
                                                            md='auto'
                                                            xs={12}>

                                                            <Button
                                                                color="secondary"
                                                                size="medium"
                                                                variant="contained"
                                                                disabled={!item.numero}
                                                                startIcon={<IoMdCart />}
                                                                onBlur={handleBlur}
                                                                onClick={() => { handleAddItem(values) }}>
                                                                Adicionar Item
                                                            </Button>
                                                        </Grid>

                                                        <Grid item
                                                            md="auto"
                                                            xs={12}
                                                            fullWidth>
                                                            <IconButton
                                                                color="secondary"
                                                                variant="contained"
                                                                disabled={!item.numero}
                                                                children={<AiOutlineClear />}
                                                                size="small"
                                                                onClick={() => { clearFields(item) }}>
                                                            </IconButton>
                                                        </Grid>

                                                    </Grid>

                                                    <br></br>

                                                    <Grid container
                                                        direction="row"
                                                        justifyContent="flex-start"
                                                        alignItems="center"
                                                        spacing={1}  >

                                                        <Grid item
                                                            md={12}
                                                            xs={12}>

                                                            <TableContainer component={PerfectScrollbar} className={classes.container}>

                                                                <Table stickyHeader size="small" aria-label="a dense table" >
                                                                    <TableHead>

                                                                        <TableRow>

                                                                            <TableCell>
                                                                                Código LPU
                                                                            </TableCell>

                                                                            <TableCell>
                                                                                Nome
                                                                            </TableCell>

                                                                            <TableCell>
                                                                                Categoria
                                                                            </TableCell>

                                                                            <TableCell>
                                                                                Tipo
                                                                            </TableCell>

                                                                            <TableCell>
                                                                                Qtd
                                                                            </TableCell>

                                                                            <TableCell>
                                                                                Unidade
                                                                            </TableCell>

                                                                            <TableCell align="right">
                                                                                Material Unitário
                                                                            </TableCell>

                                                                            <TableCell align="right">
                                                                                Mão Obra Unitária
                                                                            </TableCell>

                                                                            <TableCell align="right">
                                                                                Total Material
                                                                            </TableCell>

                                                                            <TableCell align="right">
                                                                                Total Mão Obra
                                                                            </TableCell>

                                                                            <TableCell align="right">
                                                                                Total
                                                                            </TableCell>

                                                                            <TableCell width={10} >
                                                                                &nbsp;
                                                                            </TableCell>

                                                                        </TableRow>

                                                                    </TableHead>

                                                                    <TableBody>
                                                                        {dependencies.items.map((itemorc) => (
                                                                            <TableRow
                                                                                hover
                                                                                key={itemorc.id}
                                                                            >
                                                                                <TableCell>
                                                                                    <Box
                                                                                        alignItems="center"
                                                                                        display="flex"
                                                                                    >
                                                                                        <Avatar
                                                                                            className={classes.avatar}
                                                                                        >
                                                                                            {<Icon component={IoMdCart} style={{ color: colors.cyan[500] }} ></Icon>}
                                                                                        </Avatar>
                                                                                        {(itemorc.codigo) ? itemorc.codigo : "..."}
                                                                                    </Box>
                                                                                </TableCell>

                                                                                <TableCell width={400}>
                                                                                    {itemorc.nome}
                                                                                </TableCell>

                                                                                <TableCell >
                                                                                    {getNome(itemorc.aplicacao, dependencies.applications)}
                                                                                </TableCell>

                                                                                <TableCell >
                                                                                    {getNome(itemorc.origem, dependencies.origins)}
                                                                                </TableCell>

                                                                                <TableCell align="center">
                                                                                    {itemorc.qtd}
                                                                                </TableCell>

                                                                                <TableCell align="center">
                                                                                    {getNome(itemorc.unidade, dependencies.units)}
                                                                                </TableCell>

                                                                                <TableCell align="right">
                                                                                    {numeral(itemorc.valor).format('0.00')}
                                                                                </TableCell>

                                                                                <TableCell align="right">
                                                                                    {numeral(itemorc.instalacao).format('0.00')}
                                                                                </TableCell>

                                                                                <TableCell align="right">
                                                                                    {numeral(itemorc.qtd * itemorc.valor).format('0.00')}
                                                                                </TableCell>

                                                                                <TableCell align="right">
                                                                                    {numeral(itemorc.qtd * itemorc.instalacao).format('0.00')}
                                                                                </TableCell>

                                                                                <TableCell align="right" className={classes.input} >
                                                                                    {numeral(((itemorc.valor * itemorc.qtd) + (itemorc.instalacao * itemorc.qtd))).format('0.00')}
                                                                                </TableCell>

                                                                                <TableCell >
                                                                                    <Tooltip title="Excluir Produto">
                                                                                        <IconButton
                                                                                            color="secondary"
                                                                                            className={classes.btntreatment}
                                                                                            children={<DeleteRoundedIcon />}
                                                                                            size="medium"
                                                                                            onClick={() => { handleRemoveItem(itemorc, values) }}>
                                                                                        </IconButton>
                                                                                    </Tooltip>
                                                                                </TableCell>

                                                                            </TableRow>
                                                                        ))
                                                                        }

                                                                        {(dependencies.items.length == 0) ? (
                                                                            <TableRow  >
                                                                                {(item.total > 0.0) ? (
                                                                                    <TableCell colSpan={11} align="center" className={classes.inputErro} >
                                                                                        ERRO de Cálculo no Orçamento
                                                                                    </TableCell>
                                                                                ) : (
                                                                                    <TableCell colSpan={11} align="center" >
                                                                                        Nenhum Produto Foi Adicionado
                                                                                    </TableCell>
                                                                                )}

                                                                            </TableRow>
                                                                        ) : ('')}

                                                                    </TableBody>

                                                                    <TableFooter  >
                                                                        <TableRow>

                                                                            <TableCell align="right" colSpan={8}>

                                                                            </TableCell>

                                                                            <TableCell align="right" >
                                                                                <b>{numeral(values.valorMaterial).format('0.00')}</b>
                                                                            </TableCell>

                                                                            <TableCell align="right" >
                                                                                <b>{numeral(values.valorMaoObra).format('0.00')}</b>
                                                                            </TableCell>


                                                                            <TableCell align="right" className={(values.total > 0.0 && dependencies.items.length == 0) ? classes.inputErro : classes.input}>
                                                                                <b>{numeral(parseFloat(values.valorMaoObra) + parseFloat(values.valorMaterial)).format('0.00')}</b>
                                                                            </TableCell>

                                                                            <TableCell align="right">
                                                                            </TableCell>

                                                                        </TableRow>

                                                                    </TableFooter>

                                                                </Table>
                                                            </TableContainer>

                                                        </Grid>

                                                    </Grid>

                                                </CardContent>
                                            </Card>
                                        </Grid>

                                    </Grid>

                                </Box>

                                <Box my={1}></Box>
                                <Divider />

                                <Box my={1}>

                                    <Grid container
                                        direction="row"
                                        justify="flex-end"
                                        alignItems="baseline"
                                        spacing={1}  >

                                        <Grid
                                            item
                                            md={3}
                                            xs={12}  >
                                            <FormControlLabel
                                                control={<Checkbox
                                                    checked={values.atualizarPdf}
                                                    onChange={handleChange}
                                                    name="atualizarPdf"
                                                    id="atualizarPdf" />}
                                                label={`${(values.chavePdf) ? 'Atualizar PDF do Orçamento ao Salvar' : 'Gerar PDF do Orçamento ao Salvar'}`}
                                            />

                                        </Grid>

                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                type="submit"
                                                variant="contained">
                                                Salvar
                                            </Button>
                                        </Grid>

                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                variant="contained"
                                                onClick={() => { closeEdition() }}>
                                                Fechar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>

                            </form>
                        )}
                    </Formik>

                </DialogContent>

            </Dialog>

        </Fragment>
    );
};

export default Budget;
